var config = {}

export default {
  init(vm = 'vm', data) {
    config[vm] = data
  },
  get(vm = 'vm') {
    return config[vm]
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/getVue.js